<!--
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-10 15:07:30
-->
<template>
  <input
    class="s-input"
    type="text"
    v-bind="$props"
    @input="changeValue"
  >
</template>
<script>
export default {
  name: 'SInput',
  props: {
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: [String, Number],
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    changeValue (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>
<style lang="less" scoped>
.s-input {
  width: 460px;
  height: 52px;
  padding: 15px 10px;
  font-family: SimHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  outline: none;
  background-color: #fff;
  border: 1px solid #8d5a5a;
}
@media screen and (max-width: 750px) {
  .s-input {
    font-size: 2.6667rem ;
    padding-left: 2.1333rem; /* 18/7.5 */;
    width: 70.6667rem;
    height: 8.2667rem;
  }
}
</style>
